module.exports = __webpack_public_path__ + "static/img/4.79817d6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/eng/4.png
// module id = 8u4o
// module chunks = 0